<template>
    <section class="popup-modal">
      <div class="card">
        <div class="card-header">
          <div class="card-header-title" v-if="lang_data">
            {{
              localization("app-project-level-details", "Project level details")
            }}
          </div>
          <div class="card-header-icon" @click="$emit('close')">
            <svg viewBox="0 0 100 100" class="image is-16x16 mr-10">
              <use xlink:href="@/assets/icons/helper_sprite.svg#close" />
            </svg>
          </div>
        </div>
        <div class="card-content">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">AutoCAD ortho</label>
                <div class="select">
                  <select v-model="form.autocad_ortho_used">
                    <option value="no">{{ localization("app-no", "No") }}</option>
                    <option value="yes">
                      {{ localization("app-yes", "Yes") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field">
                <label class="label">Visual ortho</label>
                <div class="select">
                  <select v-model="form.visual_ortho_used">
                    <option value="no">{{ localization("app-no", "No") }}</option>
                    <option value="yes">
                      {{ localization("app-yes", "Yes") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field">
                <label class="label">
                  {{ localization("app-rooftop", "Rooftop") }}/{{
                    localization("app-plant", "Plant")
                  }}
                </label>
                <div class="select">
                  <select v-model="form.rooftop_or_plant">
                    <option value="plant">
                      {{ localization("app-plant", "Plant") }}
                    </option>
                    <option value="rooftop">
                      {{ localization("app-rooftop", "Rooftop") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field">
                <label class="label">
                  {{ localization("app-module-type", "Module type") }}
                </label>
                <div class="select">
                  <select v-model="form.module_type">
                    <option value="pc">
                      {{
                        localization("app-poly-crystalline", "Poly Crystalline")
                      }}
                    </option>
                    <option value="tf">
                      {{ localization("app-thinfilm", "Thinfilm") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">
                  {{ localization("app-tracker", "Tracker") }}/{{
                    localization("app-non-tracker", "Non Tracker")
                  }}
                </label>
                <div class="select">
                  <select v-model="form.tracker_or_nontracker">
                    <option value="nontracker">
                      {{ localization("app-non-tracker", "Non Tracker") }}
                    </option>
                    <option value="tracker">
                      {{ localization("app-tracker", "Tracker") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field">
                <label class="label">
                  {{
                    localization(
                      "app-thermal-raw-images-referred",
                      "Thermal Raw Images referred"
                    )
                  }}
                </label>
                <div class="select">
                  <select v-model="form.thermal_raw_images_referred">
                    <option value="no">{{ localization("app-no", "No") }}</option>
                    <option value="yes">
                      {{ localization("app-yes", "Yes") }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="field">
                <label class="label">
                  {{
                    localization("app-visual-raw-images", "Visual Raw images")
                  }}/{{
                    localization(
                      "app-visual-ortho-referred",
                      "Visual ortho referred"
                    )
                  }}
                </label>
                <div class="select">
                  <select v-model="form.visual_images_referred">
                    <option value="no">{{ localization("app-no", "No") }}</option>
                    <option value="yes">
                      {{ localization("app-yes", "Yes") }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label">
              {{ localization("app-module-make", "Module make") }}
            </label>
            <div class="control">
              <input
                v-model="form.module_make"
                class="input"
                type="text"
                placeholder="Module make"
              />
            </div>
          </div>
          <div class="field">
            <label class="label">
              {{ localization("app-comments", "Comments") }}
            </label>
            <div class="control">
              <textarea
                class="textarea"
                v-model="form.comment"
                :placeholder="
                  is_disabled
                    ? 'Why was Thermal Ortho not enough to mark the issues?'
                    : 'Type your comment here'
                "
              ></textarea>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="button mx-2" @click="$emit('close')">Cancel</div>
          <div
            class="button is-primary"
            :class="{
              'is-loading is-disabled': is_loading,
            }"
            :disabled="is_disabled"
            @click="$emit('save', form)"
          >
            Save
          </div>
        </div>
      </div>
    </section>
</template>

  <script>  
  export default {
    name: "PublicPopup",
    props: {
      is_loading: {
        type: Boolean,
      },
      project_uid: {
        type: String,
      },
      asset_uid: {
        type: String,
      },
    },
    data() {
      return {
        form: {
          project_uid: "",
          autocad_ortho_used: "no",
          visual_ortho_used: "no",
          rooftop_or_plant: "plant",
          module_type: "pc",
          tracker_or_nontracker: "nontracker",
          thermal_raw_images_referred: "no",
          visual_images_referred: "no",
          module_make: null,
          comment: "",
        },
      };
    },
    computed: {
      is_disabled() {
        return (
          (this.form.thermal_raw_images_referred === "yes" ||
            this.form.visual_images_referred === "yes") &&
          !this.form.comment.length
        );
      },
    },
    created() {
        if (localStorage.getItem(`tags_for_ortho_asset_uid=${this.asset_uid}`))
          this.form = JSON.parse(
            localStorage.getItem(`tags_for_ortho_asset_uid=${this.asset_uid}`)
          );
        else this.form.project_uid = this.project_uid;
      },
  };
  </script>

  <style lang="scss" scoped>
  .popup-modal {
    border-radius: 10px;
    background: white;
    height: auto;
    .card {
      &-content {
        padding: 16px;
        max-height: 400px;
        overflow: auto;

        .select,
        select {
          width: 200px;
        }
      }
      &-footer {
        padding: 12px;
        display: flex;
        justify-content: end;
        align-items: center;

        .button.is-primary {
          margin-left: 8px;
        }
      }
    }
  }
  </style>